export enum CarEvidenceStatus {
  awaitingReview = "AWAITING_REVIEW",
  anpgAccepted = "ANPG_ACCEPTED",
  requiresOperatorReview = "REQUIRES_OPERATOR_REVIEW",
  acceptedWithComment = "ACCEPTED_WITH_COMMENT",
  evidenceReviewed = "EVIDENCE_REVIEWED",
}
